import canvasTemplates from "./canvasTemplates";
import assessment from "./assessment";
import assessmentDirectory from "./assessmentDirectory";
import moduleTemplates from "./moduleTemplates";
import modules from "./modules";
import trainingPlans from "./trainingPlans";
const content = {
    modules,
    moduleTemplates,
    assessment,
    assessmentDirectory,
    trainingPlans,
    canvasTemplates,
};
export default content;
